import { INVOICE_PAGE_SIZE_OPTIONS } from "@nlc/shared-types";
import { Select } from "react-aria-components";

import { Pagination } from "@/components/pagination";
import {
  SelectButton,
  SelectListBox,
  SelectListItem,
  SelectPopover,
} from "@/components/select";

interface InvoicesFooterProps {
  limit: number;
  onLimitChange: (limit: number) => void;
  onPageChange: (page: number) => void;
  page: number;
  totalPages: number;
}

export function InvoicesFooter({
  limit,
  onLimitChange,
  onPageChange,
  page,
  totalPages,
}: InvoicesFooterProps) {
  return (
    <div className="@container flex items-center gap-md border-t justify-center border-border-secondary px-3xl pt-xl pb-2xl md:pt-lg md:pb-xl md:justify-between ">
      <Select
        aria-label="Invoices per page"
        className="hidden w-auto min-w-[159px] shrink-0 md:block"
        onSelectionChange={(key) => {
          if (key !== null) onLimitChange(Number(key));
        }}
        selectedKey={limit}
      >
        <SelectButton className="cursor-pointer text-sm font-semibold text-button-secondary-fg">
          Show:&nbsp;
        </SelectButton>

        <SelectPopover>
          <SelectListBox>
            {INVOICE_PAGE_SIZE_OPTIONS.map((size) => (
              <SelectListItem
                className="text-button-secondary-fg"
                id={size}
                key={size}
              >
                {size} items
              </SelectListItem>
            ))}
          </SelectListBox>
        </SelectPopover>
      </Select>

      <Pagination
        alwaysShowPages
        currentPage={page}
        onPageChange={onPageChange}
        totalPages={totalPages}
      />
    </div>
  );
}
